export const PDP_DESKTOP_AGGREGATION_FEB_2025 = 'PDPDesktopAggregation_Feb2025';
export const PDP_SELLER_REVIEWS = 'PDP_SellerReviews_Nov2025';
export const PDP_ESTIMATE_SIMILAR_SOLD_TEST_NAME = 'PDP_1stDibsEstimateSimilarSold_Oct2025';
export const PDP_PERSONALIZED_DYNAMIC_CATALOGUE_DEC_2025 =
    'PDP_PersonalizedDynamicCatalogue_Dec2025';
export const NEW_ARRIVALS_TEST_NAME = 'Browse_NewArrivalsLogic_Feb2026';
export const PDP_SIMILAR_SOLD_ITEMS_MODULE_TEST_NAME = 'PDP_SimilarSoldPill_Feb2026';
export const PDP_LARGER_ITEMS_MAR_2026 = 'PDP_ImageGalleryUX_March2026';
